export default {
  snackbarGlobal: {
    visibilidade: false,
    duracao: 5000,
    mensagem: "",
    cor: ""
  }
};
